var autoplayEnabled = $(window).width() < 1024; // Enable autoplay only for mobile & tablet

$(".product-slider").owlCarousel({
    loop: true, 
    margin: 10,
    nav: false,
    dots: true,
    autoplay: autoplayEnabled, // Autoplay only for mobile & tablet
    autoplayTimeout: 8000,
    responsive: {
        0: { items: 2, autoplay: true },   // Mobile (autoplay enabled)
        768: { items: 2, autoplay: true },  // Tablet (autoplay enabled)
        1024: { items: 4, autoplay: false } // Desktop (autoplay disabled)
    }
});


// Circle-Collection Js
$('.slider-container .slider').slick({
  infinite: true,
  slidesToShow: 8, // Default for desktop
  slidesToScroll: 2,
  autoplay: true,         // Enables autoplay
  autoplaySpeed: 3000,    // Sets autoplay speed (3000ms = 3 seconds)
  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

